var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.677 13.107a3.166 3.166 0 0 1-2.783-2.79C.78 9.242.682 8.138.682 7.013s.097-2.23.212-3.304A3.166 3.166 0 0 1 3.677.919C4.758.799 5.868.695 7 .695s2.242.103 3.323.224a3.166 3.166 0 0 1 2.783 2.79c.115 1.075.212 2.179.212 3.304s-.097 2.229-.212 3.304a3.166 3.166 0 0 1-2.783 2.79q-.63.071-1.273.127a.493.493 0 0 1-.534-.494v-2.695h1.522a.5.5 0 0 0 .5-.5V8.018a.5.5 0 0 0-.5-.5H8.516v-1.01a1.01 1.01 0 0 1 1.011-1.011h.511a.5.5 0 0 0 .5-.5V3.98a1.01 1.01 0 0 0-1.01-1.01h-.506a3.033 3.033 0 0 0-3.033 3.032v1.516H4.467a.5.5 0 0 0-.5.5v1.527a.5.5 0 0 0 .5.5H5.99v2.735a.49.49 0 0 1-.524.494a42 42 0 0 1-1.788-.167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFace);
export default __webpack_public_path__ + "static/media/ic_face.61cdd03de18ef700a093e39e62facfed.svg";
export { ForwardRef as ReactComponent };